import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { authFeatureKey } from "../../store/featureKeys";
import "./BottomButtons.css";
import { Web3ReactProvider, useWeb3React } from "@web3-react/core";
import { Redirect } from "react-router-dom";
import { ethers } from "ethers";
import Web3Modal from "web3modal";
import Web3 from "web3";
import NFT from "../../abi/nft.json";
import Market from "../../abi/marketplace.json";

import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Typography } from "@material-ui/core";

import { nftmarketaddress, nftaddress } from "../../config/polygon.js";
import { ethnftmarketaddress, ethnftaddress } from "../../config/ethereum.js";

import { maticToWei } from "../utils/PriceUtils";

// Aws Storage

import { DataStore } from "@aws-amplify/datastore";
import {
  NFTS,
  Chain,
  NFTSINFLUENCERS,
  NFTSNFTSINFLUENCERS,
} from "../../models";
import firebase from "./../../firebase";

import axios from "axios";

// aws s3
// import S3 from "react-aws-s3";

import { NFTStorage, File } from "nft.storage";

// Stylesheet
import "./CreateNFTs.css";
import { toast } from "react-hot-toast";

// Sections
import MetaData from "./sections/metaData/MetaData";
import { Influencer } from "./sections/influencer/Influencer";
import Price from "./sections/price/Price";
import ChooseCrypto from "./sections/chooseCrypto/ChooseCrypto";

import PreloaderInner from "./../../components/preloader/loader";

const apiKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJkaWQ6ZXRocjoweGVkNzZmMzNBMWFkQjk2MEY3Yjc0YzE3OENGM2YwN0I0YWJkMWMyOTAiLCJpc3MiOiJuZnQtc3RvcmFnZSIsImlhdCI6MTYzODk0MjcwNTM0NiwibmFtZSI6Imxvb3BnZW0ifQ.yHeKad_It43iInwFhz0Mtj5gWLyBzV5EjvXX7haCP_Q";
const client = new NFTStorage({ token: apiKey });

function CreateNFTs() {
  const history = useHistory();
  const auth = useSelector((state) => {
    return state[authFeatureKey];
  });
  let provider = auth.provider;
  const web3 = new Web3(provider);
  const [loaderText, setLoaderText] = useState("");
  const [loader, setLoader] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState();
  const [data, setData] = useState({
    name: "",
    description: "",
    tags: [],
    image: "",
    url: "",
    cryptoType: "Ethereum",
    imageType: "",
  });
  const [inf, setInfluencer] = useState([]);
  const [price, setPrice] = useState("");
  const [isSubmited, setSubmited] = useState(false);
  var file;
  const onChange = async () => {
    const regex =
      /^((javascript:[\w-_]+(\([\w-_\s,.]*\))?)|(mailto:([\w\u00C0-\u1FFF\u2C00-\uD7FF-_]+\.)*[\w\u00C0-\u1FFF\u2C00-\uD7FF-_]+@([\w\u00C0-\u1FFF\u2C00-\uD7FF-_]+\.)*[\w\u00C0-\u1FFF\u2C00-\uD7FF-_]+)|(\w+:\/\/(([\w\u00C0-\u1FFF\u2C00-\uD7FF-]+\.)*([\w\u00C0-\u1FFF\u2C00-\uD7FF-]*\.?))(:\d+)?(((\/[^\s#$%^&*?]+)+|\/)(\?[\w\u00C0-\u1FFF\u2C00-\uD7FF:;&%_,.~+=-]+)?)?(#[\w\u00C0-\u1FFF\u2C00-\uD7FF-_]+)?))$/;
    if (!regex.test(data.url)) {
      toast.error("Please enter valid url");
      console.log(data.url);
    }
    setSubmited(true);
    file = selectedFile;
    if (!data.name || !data.description || !selectedFile || !price) {
      toast.error("Please enter required fields!");
    } else {
      setLoader(true);
      setLoaderText("Uploading your NFT...");
      var extension = file.name.split(".");
      const fileName =
        (Math.random() + 1).toString(36).substring(2) + "." + extension[1];
      const ref = await firebase.storage().ref(`/files/${fileName}`);
      const uploadTask = ref.put(file);
      uploadTask.on("state_changed", console.log, console.error, () => {
        ref.getDownloadURL().then(async (url) => {
          if (url) {
            setLoaderText("Pinning on IPFS....");
            setData({ ...data, image: url });
            try {
              const f = new File([file], `${fileName}`, {
                type: file.type,
              });
              // const cid = await client.storeBlob(file);
              console.log({
                name: data.name,
                description: data.description,
                image: f,
                tags: data.tags,
                url: data.url,
              });
              const md = await client.store({
                name: data.name,
                description: data.description,
                image: f,
                tags: data.tags,
                url: data.url,
              });

              if (md.ipnft) {
                createSale(md.ipnft, url);
              }
            } catch (error) {
              console.log("Error uploading file:", error);
              setLoader(false);
            }
          }
        });
      });
    }
  };

  const createSale = async (ipnft, url) => {
    //create the items and list them on the marketplace
    setLoader(true);
    try {
      const account = await web3.eth.getAccounts();
      // we want to create the token
      const ci = await web3.eth.getChainId();
      // we want to create the token
      if (
        data.cryptoType === "Polygon" &&
        //window.ethereum.networkVersion === "80001"
        `${ci}` === "80001"
      ) {
        setLoaderText("Minting the NFT...");
        // Nft contract for polygon change this for polygon mainnet
        const contractNftPoly = new web3.eth.Contract(NFT, nftaddress);

        // Transaction for create token
        var mintTransactionPoly = await contractNftPoly.methods
          .createToken(ipnft)
          .send({ from: `${account[0]}` });
        
          let tokenId = parseInt(
          mintTransactionPoly.events.Transfer.returnValues.tokenId
        );
        const pr = maticToWei(price);

        // list the item for sale on the marketplace
        // change this contract address for mainnet
        setLoaderText("Adding NFT to Loopgem marketplace...");
        const contractMarketPoly = new web3.eth.Contract(
          Market,
          nftmarketaddress
        );
        
        // here polygon mainnet address for nfts will be changed
        var listTransactionPoly = await contractMarketPoly.methods
          .makeMarketItem(nftaddress, tokenId, pr)
          .send({ from: `${account[0]}` });
      } else if (
        data.cryptoType === "Ethereum" &&
        `${ci}` === "4" // chnge this to ethereum mainnet chainid for mainnet
      ) {
        setLoaderText("Minting the NFT...");
        // Nft Ethereum mainnet address needs to be added here for mainnet
        const contractNftEth = new web3.eth.Contract(NFT, ethnftaddress);
        var mintTransactionETH = await contractNftEth.methods
          .createToken(ipnft)
          .send({ from: `${account[0]}` });
        
          let tokenId = parseInt(
          mintTransactionETH.events.Transfer.returnValues.tokenId
        );
        //let tokenId = tId.toNumber();
        const pr = web3.utils.toWei(price, "ether");

        // list the item for sale on the marketplace
        // ethereum mainnet address for marketplace will be added here
        setLoaderText("Adding NFT to Loopgem marketplace...");
        const contractMarketEth = new web3.eth.Contract(
          Market,
          ethnftmarketaddress
        );
        
        // nft mainnet address will be added here for ethereum mainnet
        var listTransactionETH = await contractMarketEth.methods
          .makeMarketItem(ethnftaddress, tokenId, pr)
          .send({ from: `${account[0]}` });
        console.log("ETH Txn", listTransactionETH);
      } else {
        alert("You are on wrong chain to mint token on " + data.cryptoType);
        setLoader(false);
      }

      let TokenId = {};
      let ItemId = {};
      let ca = {};
      let oa = {};
      let sold = {};
      let mintTx = {};
      let listTx = {};
      if (
        data.cryptoType === "Polygon" &&
        //window.ethereum.networkVersion === "80001"
        `${ci}` === "80001"
      ) {
        TokenId =
          listTransactionPoly.events.MarketTokenListed.returnValues.tokenId;

        ItemId =
          listTransactionPoly.events.MarketTokenListed.returnValues.itemId;
        ca = listTransactionPoly.events.MarketTokenListed.returnValues.seller;
        // Marking the owner at the start same as the creator
        oa = listTransactionPoly.events.MarketTokenListed.returnValues.seller;
        sold = listTransactionPoly.events.MarketTokenListed.returnValues.sold;
        mintTx = mintTransactionPoly.transactionHash;
        listTx = listTransactionPoly.transactionHash;
      } else if (
        data.cryptoType === "Ethereum" &&
        `${ci}` === "4" // chnge this to ethereum mainnet chainid for mainnet
      ) {
        TokenId =
          listTransactionETH.events.MarketTokenListed.returnValues.tokenId;

        ItemId =
          listTransactionETH.events.MarketTokenListed.returnValues.itemId;
        ca = listTransactionETH.events.MarketTokenListed.returnValues.seller;
        // Marking the owner at the start same as the creator
        oa = listTransactionETH.events.MarketTokenListed.returnValues.seller;
        sold = listTransactionETH.events.MarketTokenListed.returnValues.sold;
        mintTx = mintTransactionETH.transactionHash;
        listTx = listTransactionETH.transactionHash;
      }

      setLoaderText("Almost done...."); //adding nft to firebase
      await firebase
        .firestore()
        .collection("NFTDataModel")
        .add({
          imageUrl: url,
          description: data.description,
          influenceCollection: JSON.stringify(inf),
          name: data.name,
          sold: false,
          tags: data.tags,
          chain: data.cryptoType,
          ipfsHash: ipnft,
          price: parseFloat(price),
          sold: sold,
          tokenid: TokenId,
          itemid: ItemId,
          creatorAddress: ca,
          ownerAddress: ca,
          url: data.url,
          views: 0,
          imageType: data.imageType,
          likes: 0,
          score: 0,
          createdAt: new Date(),
          nftcontractaddress: data.cryptoType === "Polygon" ? nftaddress : ethnftaddress,
          nftmarketcontractaddress: data.cryptoType === "Polygon" ? nftmarketaddress : ethnftmarketaddress,
          listed: true
        })
        .then((docRef) => {
          firebase
            .firestore()
            .collection("NFTTransactionHistory")
            .add({
              createdAt: new Date(),
              nftid: String(docRef.id),
              from: "",
              to: ca,
              price: 0.0,
              chain: data.cryptoType,
              txnHash: mintTx,
              txnType: "MINT",
            })
            .then((docRef2) => {
              firebase
                .firestore()
                .collection("NFTTransactionHistory")
                .add({
                  createdAt: new Date(),
                  nftid: String(docRef.id),
                  from: ca,
                  to: "",
                  price: parseFloat(price),
                  chain: data.cryptoType,
                  txnHash: listTx,
                  txnType: "LISTED",
                });
            })
            .catch((error) => {
              console.log("Error", error);
              setLoader(false);
            });
          setLoader(false);
          history.push(`/explore/${ipnft}`);
        })
        .catch((error) => {
          toast.error(error.message);
          setLoader(false);
        });
    } catch (err) {
      console.log(err);
      setLoader(false);
    }
  };

  const check = async (e) => {
    e.preventDefault();
    const a = await web3.eth.getAccounts();
    console.log(a[0]);
    const t = data.name;
    console.log(t);
  };

  const cancelNFT = () => {
    history.push(`/`);
    //  const ifps= "bafyreiaiwzrcbr2da2s4swbazpp5efhulnmotivut523zkaekoib2gjot4"
    //  history.push(`/nft=${ifps}/influencer=sa`);
  };

  return (
    <div>
      {loader && <PreloaderInner loaderText={loaderText} />}
      <h1 className="space-heading margin-heading">CREATE NFT</h1>
      <form className="createnft-form">
        <MetaData
          selectedFile={selectedFile}
          isSubmited={isSubmited}
          setData={setData}
          data={data}
          setSelectedFile={setSelectedFile}
        ></MetaData>

        <ChooseCrypto setData={setData} data={data} />
        <Price
          isSubmited={isSubmited}
          setPrice={setPrice}
          price={price}
          type={data.cryptoType}
        />
        <div
          className="bottom-buttons"
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            flexDirection: "row",
            gap: "20px",
          }}
        >
          <Button
            variant="contained"
            style={{
              marginright: "20px",
              marginleft: "20px",
              width: "400px",
              padding: "20px",
            }}
            onClick={(e) => onChange(e)}
          >
            <Typography style={{ fontSize: "16px" }} variant="h5">
              Create
            </Typography>
          </Button>
          <Button
            variant="outlined"
            style={{
              marginright: "20px",
              marginleft: "20px",
              width: "400px",
              padding: "20px",
              color: "white",
              border: "2px dashed gray",
            }}
            onClick={() => cancelNFT()}
          >
            <Typography style={{ fontSize: "16px" }} variant="h5">
              Cancel
            </Typography>
          </Button>
        </div>
      </form>
    </div>
  );
}

export default CreateNFTs;

// MetaData: Data Tag Link Description Image
// Price
// Chain
// Influencers
